import { apiClient } from './client'

export type Annonce = {
  id: number
  titre: string
  texte: string
  date_debut: string | null
  date_fin: string | null
  actif: boolean
  centre: boolean
  ordre: number
}

export type AnnonceInput = {
  titre?: string
  texte: string
  date_debut?: string | null
  date_fin?: string | null
  actif?: boolean
  centre?: boolean
  ordre?: number
}

export async function listAnnonces(): Promise<Annonce[]> {
  const { data } = await apiClient.get<Annonce[]>('/api/annonces')
  return data
}

// ── Admin ──

export async function adminListAnnonces(): Promise<Annonce[]> {
  const { data } = await apiClient.get<Annonce[]>('/api/annonces/admin/all')
  return data
}

export async function createAnnonce(a: AnnonceInput): Promise<void> {
  await apiClient.post('/api/annonces', a)
}

export async function updateAnnonce(id: number, a: Partial<AnnonceInput>): Promise<void> {
  await apiClient.put(`/api/annonces/${id}`, a)
}

export async function deleteAnnonce(id: number): Promise<void> {
  await apiClient.delete(`/api/annonces/${id}`)
}
